module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/wx_qrcode.bef5f5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/wx_qrcode.png
// module id = 9ud/
// module chunks = 3